import stMinVersionMet from './stMinVersionMet.js'
import stMaxVersionMet from './stMaxVersionMet.js'
import { getProperty } from 'dot-prop'

/**
 * Whether a property group should appear in the UI.
 * - adminOnly: hidden for non-admins
 * - min_version / max_version.st: hidden when firmware is out of range (everyone)
 */
export default function propertyGroupVisible(propertyGroup, { stVersion, isAdmin } = {}) {
    if (!propertyGroup) {
        return false
    }
    if (propertyGroup.adminOnly && !isAdmin) {
        return false
    }
    const minVersions = propertyGroup.min_version
    if (minVersions != null) {
        const stMin = getProperty(minVersions, 'st')
        if (stMin != null && !stMinVersionMet(stVersion, stMin)) {
            return false
        }
    }
    const maxVersions = propertyGroup.max_version
    const stMax = getProperty(maxVersions, 'st')
    if (!stMaxVersionMet(stVersion, stMax)) {
        return false
    }
    return true
}

export function visiblePropertyGroups(propertyGroups, options) {
    if (!propertyGroups) {
        return {}
    }
    const visible = {}
    for (const [name, group] of Object.entries(propertyGroups)) {
        if (propertyGroupVisible(group, options)) {
            visible[name] = group
        }
    }
    return visible
}
